import Orbit from '@orbit/core';
export default class TransformBuilder {
  constructor(settings = {}) {
    this._recordInitializer = settings.recordInitializer;
  }

  get recordInitializer() {
    return this._recordInitializer;
  }
  /**
   * Instantiate a new `addRecord` operation.
   */


  addRecord(record) {
    if (this._recordInitializer) {
      this._recordInitializer.initializeRecord(record);
    }

    return {
      op: 'addRecord',
      record
    };
  }
  /**
   * Instantiate a new `updateRecord` operation.
   *
   * @deprecated
   */


  replaceRecord(record) {
    Orbit.deprecate('The `replaceRecord` operation is deprecated in favor of `updateRecord`');
    return {
      op: 'updateRecord',
      record
    };
  }
  /**
   * Instantiate a new `updateRecord` operation.
   */


  updateRecord(record) {
    return {
      op: 'updateRecord',
      record
    };
  }
  /**
   * Instantiate a new `removeRecord` operation.
   */


  removeRecord(record) {
    return {
      op: 'removeRecord',
      record
    };
  }
  /**
   * Instantiate a new `replaceKey` operation.
   */


  replaceKey(record, key, value) {
    return {
      op: 'replaceKey',
      record,
      key,
      value
    };
  }
  /**
   * Instantiate a new `replaceAttribute` operation.
   */


  replaceAttribute(record, attribute, value) {
    return {
      op: 'replaceAttribute',
      record,
      attribute,
      value
    };
  }
  /**
   * Instantiate a new `addToRelatedRecords` operation.
   */


  addToRelatedRecords(record, relationship, relatedRecord) {
    return {
      op: 'addToRelatedRecords',
      record,
      relationship,
      relatedRecord
    };
  }
  /**
   * Instantiate a new `removeFromRelatedRecords` operation.
   */


  removeFromRelatedRecords(record, relationship, relatedRecord) {
    return {
      op: 'removeFromRelatedRecords',
      record,
      relationship,
      relatedRecord
    };
  }
  /**
   * Instantiate a new `replaceRelatedRecords` operation.
   */


  replaceRelatedRecords(record, relationship, relatedRecords) {
    return {
      op: 'replaceRelatedRecords',
      record,
      relationship,
      relatedRecords
    };
  }
  /**
   * Instantiate a new `replaceRelatedRecord` operation.
   */


  replaceRelatedRecord(record, relationship, relatedRecord) {
    return {
      op: 'replaceRelatedRecord',
      record,
      relationship,
      relatedRecord
    };
  }

}